<template>
  <div class="echarts" :style="`height:${height};width:${width};`"></div>
</template>
<script>
import * as echarts from 'echarts';
import 'echarts/lib/component/legendScroll';
export default {
  name: 'RexCharts',
  data: function () {
    return {
      myChart: {},
    };
  },
  props: {
    option: {},
    clickEvent: undefined,
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    uncombine: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.drawEcharts();
    window.addEventListener('resize', this.myChart.resize);
  },
  beforeUnmount() {
    if (this.myChart.dispose) {
      this.myChart.dispose();
    }
    window.removeEventListener('resize', this.myChart.resize);
  },
  methods: {
    drawEcharts() {
      const el = this.$el;
      this.myChart = echarts.init(el, '');
      this.myChart.setOption(this.option);
      this.myChart.on('click', (params) => {
        if (!this.clickEvent) {
          return;
        }
        this.clickEvent(params);
      });
    },
  },
  watch: {
    deep: true,
    option(newVal, oldVal) {
      if (this.myChart) {
        if (newVal) {
          this.myChart.setOption(newVal, true); // clear cache
        } else {
          this.myChart.setOption(oldVal, true);
        }
      } else {
        this.drawEcharts();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.test {
  height: 300px;
}
</style>
